import React from 'react';
import { DateTimeFormatter } from '../../../../../../infrastructure/implementations/date-formatter';
import { getFormattedTimezoneOffset, utcToZonedTime } from '../../../../../../infrastructure/utils/date-fns-overrides.utils';
import { isSameDay } from 'date-fns';
import { getMeetingArtifactDateTimeString } from '../../../../../../infrastructure/utils/date.util';

export interface IMeetingArtifactListItemDayProps {
    startDateTime: Date;
    eventTimeZone: string;
    dateTimeFormatter: DateTimeFormatter;
}

const MeetingArtifactListItemDay = ({
    startDateTime,
    eventTimeZone,
    dateTimeFormatter,
}: IMeetingArtifactListItemDayProps): JSX.Element => {

    const startTime = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );
    const startTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimeZone
    );

    const isEventTimezoneTimeDiffers = startTimeInEventTimezone !== startTime;

    return (
        <>
            <div className='meeting-artifact-list__day-time'>
                {getMeetingArtifactDateTimeString(
                    dateTimeFormatter,
                    startDateTime,
                    eventTimeZone
                )}
            </div>
            { !isSameDay(startDateTime, utcToZonedTime(startDateTime, eventTimeZone)) &&
                <div className=' m-top-6px
                    meeting-artifact-list__text
                    meeting-artifact-list__text--small
                    meeting-artifact-list__text--date-and-time'
                    data-testid='local-day'
                >
                    {getMeetingArtifactDateTimeString(
                        dateTimeFormatter,
                        startDateTime,
                    )}
                </div>
            }
            { isEventTimezoneTimeDiffers &&
                <div className='meeting-artifact-list__text
                    meeting-artifact-list__text--small
                    meeting-artifact-list__text--date-and-time'
                    data-testid='local-time'>
                    {startTime} ({getFormattedTimezoneOffset(startDateTime)})
                </div>
            }
        </>
    );
};

export default MeetingArtifactListItemDay;
